"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
exports.defaultValues = {
    type: 'invalid'
};
/** Factory that generates Immutable [[IUnsupportedCondition]] */
exports.UnsupportedConditionRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable version of the [[IUnsupportedCondition]] */
var ImmutableUnsupportedCondition = /** @class */ (function (_super) {
    __extends(ImmutableUnsupportedCondition, _super);
    function ImmutableUnsupportedCondition() {
        return _super.call(this) || this;
    }
    return ImmutableUnsupportedCondition;
}(exports.UnsupportedConditionRecord));
exports.ImmutableUnsupportedCondition = ImmutableUnsupportedCondition;
//# sourceMappingURL=unsupported-conditions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/unsupported-conditions.js
// module id = 1114
// module chunks = 0